import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { ButtonWithCount } from '../../../shared/components/ButtonWithCount'
import { useAppliedFilters } from '../../hooks/useAppliedFilters'
import styles from '../../ProductListingPage.module.scss'
import { ReviewsTemplateContext } from '../../ReviewsTemplateContext'
import { ProductCount, ProductListHeader, SortMenu } from '../'

export const ReviewsSortby: FunctionComponent = () => {
  const { state } = useContext(ReviewsTemplateContext)
  const { productsWithPagination, sortByMenu, filters, needsBasedFilters } =
    state?.productListingPageData
  const { filterCount } = useAppliedFilters(filters, needsBasedFilters)

  return (
    <ProductListHeader>
      <ProductCount
        {...productsWithPagination.productCount}
        className={styles.productCountInSortby}
        data-testid="sortby-product-count"
      />
      <SortMenu
        items={sortByMenu.items}
        defaultOption={sortByMenu.defaultOption}
        data-testid="sort-menu"
      />
      <ButtonWithCount
        count={filterCount}
        onClick={() => state.filterContext.setIsOverlayFiltersDisplayed(true)}
        data-testid="filter-button"
        filterButton={true}
      >
        Filters
      </ButtonWithCount>
    </ProductListHeader>
  )
}
